export default "__VITE_ASSET__BICvCXeE__"